import { autoinject, customElement } from 'aurelia-framework';
import { EntityPickerBaseCustomElement } from 'General/Resources/Elements/EntityPicker/EntityPickerBase';

@autoinject
@customElement('entity-picker')
export class EntityPickerCustomElement extends EntityPickerBaseCustomElement {}